
const Index = () => import(/* webpackChunkName: "brand" */ './index.vue');
const List = () => import(/* webpackChunkName: "brand" */ './components/List.vue');

export default [
  {
    path: 'brand',
    name: 'brand',
    component: Index,
    title: 'brand',
    redirect: { name: 'brand-list' },
    children: [
      {
        path: 'list',
        name: 'brand-list',
        component: List,
      },      
    ],
  },
]
